import { render, staticRenderFns } from "./deliveryEffiChannel.vue?vue&type=template&id=4bb4712a&scoped=true"
import script from "./deliveryEffiChannel.vue?vue&type=script&lang=js"
export * from "./deliveryEffiChannel.vue?vue&type=script&lang=js"
import style0 from "./deliveryEffiChannel.vue?vue&type=style&index=0&id=4bb4712a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4712a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb4712a')) {
      api.createRecord('4bb4712a', component.options)
    } else {
      api.reload('4bb4712a', component.options)
    }
    module.hot.accept("./deliveryEffiChannel.vue?vue&type=template&id=4bb4712a&scoped=true", function () {
      api.rerender('4bb4712a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/deliveryEffiChannel.vue"
export default component.exports